import { isPlain } from 'dpl/util/object';

/**
 * Generic error extraction func for the convention we've adopted for rails
 */
export default function getServerErrorsFromResponseJson(json) {
  if (isPlain(json)) {
    const { error_messages: errorMessages, error } = json;

    if (errorMessages) {
      if (isPlain(errorMessages)) {
        return Object.values(errorMessages)
          .reduce((errorsAcc, errorMessage) => ([
            ...errorsAcc,
            errorMessage
          ]), []);
      }

      if (json.error_messages) {
        // can be array or string
        return [].concat(json.error_messages);
      }
    }

    if (error) {
      return [error];
    }
  }

  return ['We\'re sorry, but something went wrong.', json];
}
